import { BybButtonVR } from "@Components/game/common";
import { Events } from "@Context/common/general/context";
import useI18n from "@i18n";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { CardLeftGradient } from "../cards/styled-components";
import { HeroBannerCardBottomGradient, HeroBannerCardContent, HeroBannerCardRoot } from "./styled-components";

interface IHeroBannerCard {
  challenge: any; //TODO: challenge type
  challengeText?: string;
  navText?: string;
  navTo?: string;
}

const HeroBannerCard = ({ challenge, challengeText = "", navText, navTo }: IHeroBannerCard) => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const { id, image_url, title, goal } = challenge;

  const handleClick = () => {
    Events.app.navigate.emit(
      navTo
        ? { path: navTo }
        : {
            path: `/challenges/challenge/${id}`,
            data: challenge,
          }
    );
  };

  return (
    <HeroBannerCardRoot imageUrl={image_url}>
      <HeroBannerCardContent>
        <Typography variant="textLg500" color="common.white" sx={{ marginBottom: theme.spacing(5) }}>
          {/* top text */}
          {challengeText}
        </Typography>
        <Typography variant="text8xl800" color="common.white" sx={{ marginBottom: theme.spacing(3) }}>
          {title}
        </Typography>
        <Typography variant="text1xl500" color="common.white" sx={{ marginBottom: theme.spacing(7.25) }}>
          {goal}
        </Typography>
        <Box>
          <Button color="info" onClick={handleClick}>
            {navText || i18n("challenges.play-challenge")}
          </Button>
        </Box>
      </HeroBannerCardContent>
      <CardLeftGradient />
      <HeroBannerCardBottomGradient />
    </HeroBannerCardRoot>
  );
};

export default HeroBannerCard;
